import * as React from 'react';
import { useMemo } from 'react';
import tw from 'twin.macro';
import { useAtom } from 'jotai';
import { useTranslation } from 'next-i18next';

import { BaseModal, Title } from '@restworld/ui-ds';

import { notificationModalStateAtom, notificationModalToggleAtom } from './save-research-tab.atoms';
import SavedResearchNotificationModalFooter from './saved-research-modal-footer';
import SavedResearchNotificationModalContent from './saved-research-modal-content';
import { useSavedResearchProps } from './save-research-tab.hooks';

const SavedResearchNotificationChangeModal = () => {
  const [notificationModalToggle, setNotificationModalToggle] = useAtom(notificationModalToggleAtom);
  const [notificationModalState] = useAtom(notificationModalStateAtom);
  const { title } = useSavedResearchProps();

  const { t } = useTranslation('user-settings');

  const modalTitle = useMemo(
    () =>
      notificationModalState === null ? (
        title
      ) : notificationModalState === 'unsubscribe_user_review' ? (
        <Title
          twStyle={tw`text-start lg:text-center text-[24px] lg:text-[30px] px-5 leading-[28.8px] lg:leading-[39px]`}
          content={t('explain_why_you_no_longer_want_offer_updates')}
          fontWeight="semibold"
        />
      ) : (
        ``
      ),
    [notificationModalState, t, title]
  );

  return (
    <BaseModal
      open={notificationModalToggle}
      title={modalTitle}
      footer={<SavedResearchNotificationModalFooter />}
      onClose={() => setNotificationModalToggle(false)}
      modalStyles={[tw`lg:w-[31.75rem]`]}
    >
      <SavedResearchNotificationModalContent />
    </BaseModal>
  );
};
export default SavedResearchNotificationChangeModal;
